import { keys, reduce, isNil, isEmpty } from 'lodash';
import { ContactForm } from '@models/SIO/Contact.model';
import { Validations } from '@utils/helpers';
import { IError } from '@utils/useForm';

export const validate = (values: ContactForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'salutation':
      if (isNil(value)) {
        error = { isValid: false };
      };
      break;
    case 'surname':
    case 'givname':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: "This field cannot be empty" };
        }
      }
      break;
    case 'mobileNum':
      if (isNil(value)) {
        error = { isValid: false }
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidPhoneNumber(value)) {
            error = { isValid: false, message: 'Please enter a valid mobile number' };
          }
        }
      }
      break;
    case 'emailId':
      if (isNil(value)) {
        error = { isValid: false }
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidEmail(value)) {
            error = { isValid: false, message: 'Please enter a valid email' };
          }
        }
      }
      break;
    case 'nric':
      if (values['isAvivaCustomer'] === 'Y') {
        if (isNil(value)) {
          error = { isValid: false }
        } else {
          if (isEmpty(value)) {
            error = { isValid: false, message: 'This field cannot be empty' };
          } else {
            if(!Validations.isValidateNRIC(value)) {
              error = { isValid: false, message: 'Please enter a valid NRIC' };
            }
          }
        }
      }
      break;
  }
  return error;
}